import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classes from './AudioModeChooser.module.scss';

const AudioModeChooser = props => (
  <div className={classes.container}>
    <div className={classes.title}>
      <FormattedMessage
        id="components.audioModeChooser.title"
        defaultMessage="Audio"
      />
    </div>
    <div className={classes.radioButtons}>
      <label
        className={classes.radioBtnContainer}
        data-testid="radiobtn-computer-audio"
      >
        <FormattedMessage
          id="components.audioModeChooser.computerAudio"
          defaultMessage="Computer Audio"
        />
        <input
          checked={!props.PSTNMode}
          id="computerAudio"
          name="audioMode"
          onClick={props.hidePSTN}
          type="radio"
        />
        <div className={classes.indicator} />
      </label>
      <label
        className={classes.radioBtnContainer}
        data-testid="radiobtn-computer-audio"
      >
        <FormattedMessage
          id="components.audioModeChooser.phone"
          defaultMessage="Phone"
        />
        <input
          checked={props.PSTNMode}
          id="phone"
          name="audioMode"
          onClick={props.showPSTN}
          type="radio"
        />
        <div className={classes.indicator} />
      </label>
    </div>
  </div>
);

AudioModeChooser.propTypes = {
  PSTNMode: PT.bool,
  hidePSTN: PT.func,
  showPSTN: PT.func
};

export default AudioModeChooser;
